import $ from 'jquery';
import 'select2/dist/js/select2.full';
import { isMobileSystem } from '../utils/Utils';

const init = () => {
    if (!isMobileSystem()) {
        $('.layout .select__field').each(function() {
            $(this).select2({
                width: '',
                minimumResultsForSearch: -1,
                containerCssClass: this.dataset.selectClass,
                dropdownCssClass: this.dataset.selectClass
            });
        });

        $('.modal .select__field').each(function() {
            $(this).select2({
                width: '',
                minimumResultsForSearch: -1,
                containerCssClass: this.dataset.selectClass,
                dropdownCssClass: this.dataset.selectClass,
                dropdownParent: $(this).closest('.modal__inner')
            });
        });
    } else {
        $('.select').each(function() {
            const select = this.children[0];

            if (select.options[select.selectedIndex].disabled) {
                select.classList.add('select__field--empty');
            }

            select.addEventListener('change', () => {
                select.classList.remove('select__field--empty');
            });
        });
    }
};

export default init();
